































































// Vue
import { defineComponent, PropType, computed, ref, Ref, watch } from '@vue/composition-api'

// components
import { Input, DatePicker, Select2, TextArea } from '@/components/form'

// models
import { PropOptionSelect } from '@/models'
import { EmployeeModel, ReasonForTerminationWorkModel, CessationEmployeeForm, CessationHistoryModel } from '@/models/config'

// utils
import { alerts, loading } from '@/utils'
import { today } from '@/utils/dateLibs'

// services
import { CessationEmployeeService } from '@/services/config'

export default defineComponent({
  name: 'FormCreateCessationEmployee',
  props: {
    employee: {
      type: Object as PropType<EmployeeModel>
    },
    reasons: {
      type: Array as PropType<ReasonForTerminationWorkModel[]>,
      required: true
    },
    type: {
      type: Number as PropType<number>,
      required: true
    },
    itemEdit: {
      type: Object as PropType<CessationHistoryModel>,
      default: () => null
    }
  },
  components: {
    Input,
    DatePicker,
    Select2,
    TextArea
  },
  setup (props, { emit }) {
    const form: Ref<CessationEmployeeForm> = ref({
      employee_id: props.employee?.id || 0,
      date: props?.itemEdit ? (props.type === 0 ? props.itemEdit.dateCessation : props.itemEdit.dateReEntry) : today(),
      reason_id: props?.itemEdit?.idReason || null,
      description: props?.itemEdit?.description || '',
      type: props.type
    })
    const action = computed(() => {
      return props?.itemEdit ? 'update' : 'save'
    })
    const opReasons = computed((): PropOptionSelect[] => {
      return props.reasons.map(r => {
        return {
          text: r.name,
          value: r.id
        }
      })
    })
    const isValid = computed(() => {
      if (props.type === 0) {
        if (!form.value.employee_id || !form.value.date || !form.value.reason_id || !form.value.description) {
          return false
        }
      } else {
        if (!form.value.employee_id || !form.value.date) {
          return false
        }
      }
      return true
    })
    const save = async () => {
      if (isValid) {
        loading('show')
        try {
          if (action.value === 'save') {
            await CessationEmployeeService.create(form.value)
          } else {
            const id = (props.type === 0) ? Number(props.itemEdit.idCessation) : Number(props.itemEdit.idReEntry)
            await CessationEmployeeService.update(id, form.value)
          }
          alerts.success()
          emit('save-success')
        } catch (e) {
          alerts.error()
        }
        loading('hide')
      } else {
        alerts.error('Debe completar todos los campos')
      }
    }
    watch(() => props.itemEdit, () => {
      form.value = {
        employee_id: props.employee?.id || 0,
        date: props?.itemEdit ? (props.type === 0 ? props.itemEdit.dateCessation : props.itemEdit.dateReEntry) : today(),
        reason_id: props?.itemEdit?.idReason || null,
        description: props.itemEdit.description,
        type: props.type
      }
    })
    return {
      opReasons,
      form,
      save,
      isValid
    }
  }
})
